import React from "react";

import { TermsAndConditionsTablePage } from "./termsAndConditionsTable/TermsAndConditionsTablePage";
import { TermAndConditionsFilterPage } from "./termsAndConditionsFilter/TermAndConditionsFilterPage";
import classes from "./termsAndConditionsListPage.module.css";
import { TestFilterPage } from "./termsAndConditionsFilter/testFilter/TestFilter";

export const TermsAndConditionsListPage = () => {
  return (
    <div className={classes.box}>
      {/* <TermAndConditionsFilterPage /> */}
      <TestFilterPage/>
      <TermsAndConditionsTablePage />
    </div>
  );
};
